{
  "bookmarkTitleLabel": "書籤",
  "debug": "偵錯",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Experience League 中的結果",
  "feedback": "意見回饋",
  "fetchFailed": "擷取失敗",
  "help": "說明",
  "helpDefaultFeatured": "Adobe Experience Cloud 學習與支援",
  "helpLoadError": "發生錯誤，請再試一次。",
  "noBookmarks": "將說明內容加入書籤，即可在這裡存取",
  "noBookmarksTitle": "沒有書籤",
  "noResults": "找不到任何結果",
  "noResultsMessage": "請檢查拼字或嘗試其他搜尋字詞",
  "resourcesCustomerCareLabel": "客戶服務",
  "resourcesStatusLabel": "狀態",
  "support": "支援"
}
